export default __webpack_public_path__ + "static/hero-image-d48f76d60f7d4083b29af8fe561a3f67.png";